var map = {
	"./(per 1000 live births) (NHMIS - 2019) (1).png": "fd8f",
	"./(per 1000 live births) (NHMIS - 2019).png": "fa06",
	"./(per 1000 live births) 2.png": "2d17",
	"./(per 1000 live births) NDHS_2018.png": "8d28",
	"./(per 1000 live births).png": "73b6",
	"./About-Dashboard-image.svg": "0c15",
	"./Assets/Assets/email.svg": "69db",
	"./Assets/FAQ_Asset.png": "db27",
	"./Assets/FAQ_Asset.svg": "3eb6",
	"./Custom_Dashboard_Image.svg": "868b",
	"./Group 81.png": "93ff",
	"./Hamburger Icons.zip": "c7d3",
	"./Hamburger Icons/Icon awesome-user-circle.svg": "0dbe",
	"./Hamburger Icons/ic_autorenew.svg": "eed7",
	"./Hamburger Icons/ic_contact.svg": "38c8",
	"./Hamburger Icons/ic_dots.svg": "be37",
	"./Hamburger Icons/ic_download.svg": "a6d4",
	"./Hamburger Icons/ic_dropdown.svg": "b8a2",
	"./Hamburger Icons/ic_email.svg": "97e9",
	"./Hamburger Icons/ic_feedback.svg": "b9809",
	"./Hamburger Icons/ic_folder.svg": "6c2f",
	"./Hamburger Icons/ic_help.svg": "4d37",
	"./Hamburger Icons/ic_info.svg": "9f48",
	"./Hamburger Icons/ic_play.svg": "a823",
	"./Hamburger Icons/ic_print.svg": "3788",
	"./Hamburger Icons/ic_recommendation.svg": "66c1",
	"./Hamburger Icons/ic_save.svg": "af74",
	"./Hamburger Icons/ic_share.svg": "712c",
	"./Hamburger Icons/ic_update.svg": "11bb",
	"./Hamburger Icons/ic_upload.svg": "a8ed",
	"./Hamburger Icons/ic_zoom.svg": "9e0a",
	"./Image 3.png": "8483",
	"./Logo-mob.svg": "2ea7",
	"./Logo-mob2.svg": "f934",
	"./Logo.svg": "df5e",
	"./Logo12.svg": "2eb2",
	"./Logo2.svg": "1622",
	"./Prof.Ali_Minister_of_Health.jpg": "ecf3",
	"./analytics/Bubble Chart Analysis.png": "e983",
	"./analytics/Correlation Analysis.png": "be54",
	"./analytics/Descriptive Analysis.png": "5adb",
	"./analytics/Indicator Comparison.png": "db7a",
	"./analytics/Multi-source Indicator Comparison.png": "6921",
	"./analytics/Predictive Analysis.png": "5966",
	"./analytics/bkg.png": "edec",
	"./browser.png": "2207",
	"./code.svg": "0b79",
	"./health-think/Group_2398.svg": "1995",
	"./health-think/healththink official  logo (2).svg": "f5a3",
	"./health-think/healththink official  logo.svg": "6618",
	"./health-think/master-card.svg": "47f3",
	"./health-think/profile.png": "b074",
	"./health-think/shutterstock_416638408.png": "7f6c",
	"./icons/ic_contact.svg": "ce2d",
	"./icons/ic_dashboard.svg": "2984",
	"./icons/ic_download.svg": "df29",
	"./icons/ic_email.svg": "fc5d",
	"./icons/ic_feedback.svg": "7574",
	"./icons/ic_help.svg": "4ada",
	"./icons/ic_info.svg": "1d62",
	"./icons/ic_play.svg": "93f9",
	"./icons/ic_print.svg": "87ef",
	"./icons/ic_recommendation.svg": "7d9a",
	"./icons/ic_share.svg": "b98b",
	"./icons/ic_update.svg": "4ff5",
	"./icons/ic_upload.svg": "58a9",
	"./icons/ic_zoom.svg": "475a",
	"./onboard/onboard1.png": "7ae5",
	"./open_envelope.svg": "c378"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";